<template>
  <div class="container select-source">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">
            Choose your options for starting the <span>hearing test</span>:
          </h1>
        </div>
        <div class="title-divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            Choose if you prefer to use your device speakers or headphones.
          </p>
          <p>
            Headphones will provide you with more accurate results, and unlike
            device speakers, will test your right and left ears individually.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
        <div class="button-wrapper">
          <a @click.prevent="selectSource('headphones')" href="" class="button-main">Headphones (recommended)</a>
          <a @click.prevent="selectSource('speakers')" href="" class="button-minor">Speakers</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      selectSource(source) {
        this.$store.commit('setSource', source)

        if (source === 'headphones')
          this.$router.push('/headphones-start-test')
        else
          this.$router.push('/speaker-start-test')
      }
    }
  }
</script>
